import { Typography } from '@mui/material';

import { type TerminProps } from '../../../utils';
import { AccordionWithHeading } from '../AccordionWithHeading';
import { HeadingWithTag } from '../HeadingWithTag.tsx';
import { content } from './TerminGenerellerKommentar.content';

export const TerminGenerellerKommentarCard = ({
  bordered,
  thema: { planungsinformation },
  withoutAccordion,
}: TerminProps) => {
  if (!planungsinformation) {
    // don't show anything while loading, because the whole accordion will not be shown if there is no genereller Kommentar
    return null;
  }

  if (planungsinformation.generellerKommentar === null) {
    return null;
  }

  return (
    <AccordionWithHeading
      heading={<HeadingWithTag heading={content.heading} tag="cserv" />}
      bordered={bordered}
      noAccordion={withoutAccordion}
    >
      <Typography fontSize="14px !important">{planungsinformation.generellerKommentar}</Typography>
    </AccordionWithHeading>
  );
};
